import { SceneService } from '../../services/SceneService';
import { EditorChangeType } from '../types';
import { AbstractCommand } from './AbstractCommand';

import type { Scene } from '../models/layout';
import type { VideoEditor } from '../VideoEditor';

/**
 * AddSceneCommand
 * Adds a scene to the timeline
 */
export class AddSceneCommand extends AbstractCommand {
  private scene: Scene;
  private service: SceneService;

  constructor(editor: VideoEditor, scene: Scene) {
    super(editor);
    this.scene = scene;
    this.service = new SceneService();
  }

  getName(): string {
    return 'AddSceneCommand';
  }

  execute(): boolean {
    try {
      this.service.addScene(this.editor.timeline, this.scene);
    } catch (error) {
      return false;
    }

    this.editor.markDirty();
    this.editor.notifyObservers(EditorChangeType.SCENE_ADDED, {
      sceneId: this.scene.id,
      templateId: this.scene.layout.layoutTemplateId,
    });

    return true;
  }

  undo(): boolean {
    const removed = this.service.removeScene(
      this.editor.timeline,
      this.scene.id,
    );

    if (!removed) {
      return false;
    }

    this.editor.markDirty();
    this.editor.notifyObservers(EditorChangeType.SCENE_REMOVED, {
      sceneId: this.scene.id,
    });

    return true;
  }

  redo(): boolean {
    return this.execute();
  }

  getDescription(): string {
    return `Add scene (${this.scene.layout.layoutTemplateId})`;
  }

  shouldCreateUndoRedoEntry(): boolean {
    return true;
  }
}
